import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  universityList: [],
};

export const universityListSlice = createSlice({
  name: "universityList",
  initialState,
  reducers: {
    updateUniversityList: (state, action) => {
      return {
        ...state,

        universityList: action.payload,
      };
    },
  },
});

export const { updateUniversityList } = universityListSlice.actions;

export default universityListSlice.reducer;
